export const colorMessage = {
  success: {
    background: "#21ba45",
    text: "#fff",
  },
  error: {
    background: "#db2828",
    text: "#fff",
  },
  warn: {
    background: "#ffab00 ",
    text: "#000",
  },
  info: {
    background: "#80d8ff",
    text: "#000",
  },
};

export const TIPO_INTEGRACAO_TELECOM_ID = "0D7B60A9-F267-439F-B3B9-7A7504FEABEC";

export const PLATAFORMA_DISCADOR_ID = "1AA46412-40C9-411E-B831-C1E8FDC18044";
export const PLATAFORMA_AGENTE_ID = "BD8EDDF0-C99C-4275-B0C5-A2279CC88138";
export const PLATAFORMA_WHATSAPP_ID = "3C4107B1-164A-4EDF-A0C3-2C39F97E5CFA";
export const PLATAFORMA_MOLABOX_ID = "333C8F65-3D49-48C4-9DE9-C090A9213412";
export const PLATAFORMA_CHATWOOT_ID = "7366C66C-E21D-453F-8798-BAD8D1F84697";
